import { useEffect } from "react";
import IconFA from "../../../components/icon/icon";
import { useAppointments } from "../../../hooks/useAppointments";
import { useNavigate } from "react-router-dom";

function DbAppointment() {
    const { fetchAppointments, appointments } = useAppointments();

    useEffect(() => {
        fetchAppointments();
    }, [])

    const navigate = useNavigate();
    const handleNavigate = (id) => {
        navigate(`/dashboard/appointments/${id}`);
    };

    return (
        <div className="dbAppointmentCompContainer">
            <h3 className="dbAppointmentHeading">
                Deine nächsten Termine
            </h3>
            {appointments.length === 0 ? (
                <p style={{ color: "#777" }}>Keine anstehenden Termine</p>
            ) : (
                appointments.map((appointment, index) => (
                    <div key={index} className="dbAppointmentContainer" onClick={() => handleNavigate(appointment._id)}>
                        <p style={{ margin: 0, fontWeight: "bold" }}>
                            <IconFA iconName="calendarDays" fontSize="24px" />&nbsp;
                            {appointment.formattedDate}
                        </p>
                        <p style={{ margin: 0 }}>
                            <IconFA iconName="fileLines" fontSize="24px" />&nbsp;
                            {appointment.description}
                        </p>
                        <p style={{ margin: 0, color: "#555" }}> 
                            <IconFA iconName="user" fontSize="24px"/>&nbsp;
                            {appointment.customerName}
                        </p>
                    </div>
                ))
            )}
        </div>
    );
}

export default DbAppointment;